import React, { useState, useEffect } from 'react';
import './ShareDialog.css';

function ShareDialog({ isOpen, onClose, shareUrl, snippet }) {
  const [copied, setCopied] = useState(false);
  const [thumbnail, setThumbnail] = useState(null);
  const [loadingThumbnail, setLoadingThumbnail] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setCopied(false);
      fetchThumbnail();
    }
  }, [isOpen, snippet]);

  const getVimeoVideoId = (url) => {
    if (!url) return null;
    const match = url.match(/vimeo\.com\/(\d+)/);
    return match ? match[1] : null;
  };

  const fetchThumbnail = async () => {
    if (!snippet || !snippet.streamingUrl) return;

    const videoId = getVimeoVideoId(snippet.streamingUrl);
    if (!videoId) return;

    setLoadingThumbnail(true);
    try {
      const response = await fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`);
      const data = await response.json();
      setThumbnail(data.thumbnail_url);
    } catch (error) {
      console.error('Error fetching thumbnail:', error);
    } finally {
      setLoadingThumbnail(false);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopied(true);
      setTimeout(() => {
        onClose();
      }, 1500);
    });
  };

  if (!isOpen) return null;

  return (
    <div className="share-dialog-overlay" onClick={onClose}>
      <div className="share-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="share-dialog-header">
          <h3>Share Link</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="share-dialog-content">
          {thumbnail && (
            <div className="share-preview">
              <img src={thumbnail} alt="Link preview" className="preview-thumbnail" />
              {snippet && (
                <div className="preview-details">
                  <strong>{snippet.category}</strong>
                  <p>{snippet.parent_facing_rationale}</p>
                </div>
              )}
            </div>
          )}
          {loadingThumbnail && (
            <div className="thumbnail-loading">Loading preview...</div>
          )}

          <div className="url-container">
            <input
              type="text"
              value={shareUrl}
              readOnly
              className="url-input"
            />
            {copied && (
              <span className="check-icon">✓</span>
            )}
          </div>

          <button
            className={`copy-button ${copied ? 'copied' : ''}`}
            onClick={handleCopy}
            disabled={copied}
          >
            {copied ? 'Copied!' : 'Copy Link'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ShareDialog;
